/* aa-process-story v4 2026-10-24 (compact crop chips; sizes shown on the picture): behaviour for snippets/aa-process-story.liquid ("Behind every print").
   Loaded with defer; finds every [data-aa-ps] root wherever the theme has moved it. No libraries. */
(function(){
  'use strict';
  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function q(s, c){ return (c || document).querySelector(s); }
  function qa(s, c){ return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function once(el, cb, opts){
    if (!el) return;
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var o = new IntersectionObserver(function(es){
      for (var i = 0; i < es.length; i++) { if (es[i].isIntersecting) { o.disconnect(); cb(); return; } }
    }, opts || { rootMargin: '0px 0px -12% 0px' });
    o.observe(el);
  }
  function load(u){ return new Promise(function(res){ if (!u) { res(); return; } var im = new Image(); im.onload = im.onerror = function(){ res(); }; im.src = u; }); }

  function reveal(root){
    root.classList.add('aa-ps--js');
    qa('.aa-ps-rv', root).forEach(function(el){ once(el, function(){ el.classList.add('is-in'); }); });
    var st = q('[data-ps-steps]', root);
    if (st) { if (RM) st.classList.add('is-static'); else once(st, function(){ st.classList.add('is-in'); }, { rootMargin: '0px 0px -22% 0px' }); }
  }

  /* I. Before / after slider */
  function slider(root){
    var ba = q('[data-ps-ba]', root);
    if (!ba) return null;
    var knob = q('[data-ps-knob]', ba), pos = 50, touched = false, raf = 0, drag = null;
    function set(p){
      pos = Math.max(0, Math.min(100, p));
      ba.style.setProperty('--ps-p', pos.toFixed(2) + '%');
      var r = Math.round(pos);
      knob.setAttribute('aria-valuenow', r);
      knob.setAttribute('aria-valuetext', r + ' percent before');
      ba.classList.toggle('is-lo', pos < 16);
      ba.classList.toggle('is-hi', pos > 84);
    }
    function user(){ touched = true; if (raf) { cancelAnimationFrame(raf); raf = 0; } }
    function at(x){ var r = ba.getBoundingClientRect(); return r.width ? (x - r.left) / r.width * 100 : pos; }
    function grab(e){ try { ba.setPointerCapture(e.pointerId); } catch (_) {} ba.classList.add('is-drag'); }
    ba.addEventListener('pointerdown', function(e){
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      drag = { id: e.pointerId, x: e.clientX, y: e.clientY, on: e.pointerType === 'mouse' };
      if (drag.on) { e.preventDefault(); user(); set(at(e.clientX)); grab(e); }
    });
    ba.addEventListener('pointermove', function(e){
      if (!drag || e.pointerId !== drag.id) return;
      if (!drag.on) {
        var dx = Math.abs(e.clientX - drag.x), dy = Math.abs(e.clientY - drag.y);
        if (dx < 6 && dy < 6) return;
        if (dx <= dy) { drag = null; return; }
        drag.on = true; user(); grab(e);
      }
      set(at(e.clientX));
    });
    ba.addEventListener('pointerup', function(e){
      if (drag && !drag.on && e.pointerId === drag.id) { user(); set(at(e.clientX)); }
      drag = null; ba.classList.remove('is-drag');
    });
    ba.addEventListener('pointercancel', function(){ drag = null; ba.classList.remove('is-drag'); });
    knob.addEventListener('keydown', function(e){
      var k = e.key, s = e.shiftKey ? 10 : 2, p = pos;
      if (k === 'ArrowLeft' || k === 'ArrowDown') p -= s;
      else if (k === 'ArrowRight' || k === 'ArrowUp') p += s;
      else if (k === 'PageDown') p -= 10;
      else if (k === 'PageUp') p += 10;
      else if (k === 'Home') p = 0;
      else if (k === 'End') p = 100;
      else return;
      e.preventDefault(); user(); set(p);
    });
    function peek(){
      if (RM || touched) return;
      var pts = [50, 76, 24, 50], dur = [700, 1100, 700], i = 0, t0 = 0;
      function step(t){
        if (touched) return;
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0) / dur[i]);
        var e = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
        set(pts[i] + (pts[i + 1] - pts[i]) * e);
        if (k >= 1) { i++; t0 = 0; if (i >= dur.length) { raf = 0; return; } }
        raf = requestAnimationFrame(step);
      }
      raf = requestAnimationFrame(step);
    }
    once(ba, function(){ setTimeout(peek, 400); }, { threshold: .6 });
    set(50);
    return { el: ba, a: q('[data-ps-after]', ba), b: q('[data-ps-before]', ba) };
  }

  function tabs(root, ba){
    var list = q('[data-ps-tabs]', root), src = q('[data-ps-ex]', root);
    if (!list || !ba || !src) return;
    var ex;
    try { ex = JSON.parse(src.textContent); } catch (e) { return; }
    var ts = qa('[role="tab"]', list), cur = 0, tok = 0;
    var where = q('[data-ps-where]', root), locin = q('[data-ps-locin]', root), mk = q('[data-ps-mk]', root),
        what = q('[data-ps-what]', root), cap = q('[data-ps-cap]', root), work = q('[data-ps-work]', root), artist = q('[data-ps-artist]', root);
    function data(t){ return ex[+t.getAttribute('data-i')] || {}; }
    function warm(t){ if (t._w) return; t._w = 1; var d = data(t); load(d.b); load(d.a); }
    function pick(i, focus){
      var t = ts[i];
      if (!t) return;
      cur = i;
      ts.forEach(function(x, j){ x.setAttribute('aria-selected', j === i ? 'true' : 'false'); x.tabIndex = j === i ? 0 : -1; });
      if (focus) t.focus();
      var d = data(t), my = ++tok;
      ba.el.classList.add('is-loading');
      Promise.all([load(d.b), load(d.a)]).then(function(){
        if (my !== tok) return;
        ba.b.src = d.b; ba.b.alt = d.altB || '';
        ba.a.src = d.a; ba.a.alt = d.altA || '';
        if (where) { where.src = d.w; where.alt = 'Where this detail sits in ' + d.work; if (d.ww) { where.width = d.ww; where.height = d.wh; } }
        if (locin && d['in']) { var n = d['in']; locin.style.left = n[0] + '%'; locin.style.top = n[1] + '%'; locin.style.width = n[2] + '%'; locin.style.height = n[3] + '%'; }
        if (mk && d.mk) { mk.style.setProperty('--cx', d.mk[0] + '%'); mk.style.setProperty('--cy', d.mk[1] + '%'); mk.style.setProperty('--mw', d.mk[2] + '%'); mk.style.setProperty('--mh', d.mk[3] + '%'); }
        if (what) what.textContent = d.what || '';
        if (cap) cap.textContent = d.cap || '';
        if (work) { work.textContent = d.work || ''; work.setAttribute('href', d.href || '#'); }
        if (artist) artist.textContent = d.artist || '';
        ba.el.classList.remove('is-loading');
      });
    }
    ts.forEach(function(t){
      t.addEventListener('click', function(){ var i = ts.indexOf(t); if (i !== cur) pick(i, false); });
      t.addEventListener('pointerenter', function(){ warm(t); });
      t.addEventListener('focus', function(){ warm(t); });
    });
    list.addEventListener('keydown', function(e){
      var k = e.key, n = ts.length, i = cur;
      if (k === 'ArrowRight' || k === 'ArrowDown') i = (cur + 1) % n;
      else if (k === 'ArrowLeft' || k === 'ArrowUp') i = (cur - 1 + n) % n;
      else if (k === 'Home') i = 0;
      else if (k === 'End') i = n - 1;
      else return;
      e.preventDefault(); pick(i, true);
    });
    var pid = root.getAttribute('data-pid');
    for (var i = 0; i < ts.length; i++) {
      if (pid && ts[i].getAttribute('data-pid') === pid) {
        var badge = document.createElement('span');
        badge.className = 'aa-ps-tab__this'; badge.textContent = 'This painting';
        ts[i].appendChild(badge);
        if (i > 0) { list.insertBefore(ts[i], ts[0]); ts = qa('[role="tab"]', list); pick(0, false); }
        break;
      }
    }
  }

  /* II. Crops, live from the product's frame_view */
  var SHORT = { 'Art Print': 'Art print', 'Gallery Canvas': 'Canvas', 'Framed Canvas': 'Framed canvas', 'Framed Art Print': 'Framed print', 'Framed Fine Art Print': 'Framed print', 'Matted Fine Art Print': 'Matted print', 'Matted Art Print': 'Matted print' };
  var TRIO = ['Art Print', 'Gallery Canvas', 'Framed Canvas'];
  var NB = String.fromCharCode(160);
  function size(s){
    s = String(s || '').split(' / ')[0];
    s = s.replace(/^[A-Za-z]{1,3}\s*[·•-]\s*/, '').replace(/\s*(in|inch|inches|")\s*$/i, '');
    return s.trim();
  }
  function area(s){ var m = String(s).match(/([\d.]+)\s*[×x]\s*([\d.]+)/); return m ? parseFloat(m[1]) * parseFloat(m[2]) : 0; }
  function sizes(l){
    l = l.slice().sort(function(a, b){ return area(a) - area(b); });
    return l.join(' · ') + NB + 'in';
  }
  function names(fs){
    var rest = fs.slice(), out = [];
    if (TRIO.every(function(x){ return rest.indexOf(x) > -1; })) { out.push('Print & canvas'); rest = rest.filter(function(x){ return TRIO.indexOf(x) < 0; }); }
    rest.forEach(function(x){ out.push(SHORT[x] || x); });
    return out.length < 2 ? out.join('') : out.slice(0, -1).join(', ') + ' & ' + out[out.length - 1];
  }
  function gcd(a, b){ return b ? gcd(b, a % b) : a; }
  // '8×10 · 16×20 in' -> '4:5' (the shape of the crop, read from its first size)
  function ratio(s){
    var m = String(s || '').match(/([\d.]+)\s*[×x]\s*([\d.]+)/);
    if (!m) return '';
    var a = Math.round(parseFloat(m[1]) * 10), b = Math.round(parseFloat(m[2]) * 10), d = gcd(a, b) || 1;
    return (a / d) + ':' + (b / d);
  }
  function near(a, b){ for (var i = 0; i < 4; i++) { if (Math.abs(a[i] - b[i]) > .006) return false; } return true; }

  function crops(root){
    var box = q('[data-ps-crop]', root), src = q('[data-ps-crops]', root);
    if (!box || !src) return;
    var rows;
    try { rows = JSON.parse(src.textContent); } catch (e) { return; }
    var gs = [];
    (rows || []).forEach(function(r){
      if (!r || !r.b || r.b.length !== 4) return;
      var b = r.b.map(Number), g = null;
      for (var i = 0; i < gs.length; i++) { if (near(gs[i].b, b)) { g = gs[i]; break; } }
      if (!g) { g = { b: b, rows: [], v: {} }; gs.push(g); }
      g.rows.push(r);
      (r.v || []).forEach(function(id){ g.v[String(id)] = 1; });
    });
    if (!gs.length) return;
    gs.forEach(function(g){
      var order = [], by = {};
      g.rows.forEach(function(r){
        if (order.indexOf(r.f) < 0) { order.push(r.f); by[r.f] = []; }
        var s = size(r.s);
        if (s && by[r.f].indexOf(s) < 0) by[r.f].push(s);
      });
      var keys = [], fk = {};
      order.forEach(function(f){ var k = by[f].join('|'); if (!fk[k]) { fk[k] = []; keys.push(k); } fk[k].push(f); });
      g.lines = keys.map(function(k){ return { s: sizes(k.split('|')), n: names(fk[k]) }; });
      g.label = g.lines.map(function(l){ return l.n; }).join(' · ');
      g.long = g.lines.map(function(l){ return l.n + ', ' + l.s; }).join('; ');
      g.ratio = ratio((g.lines[0] || {}).s);
    });
    var rc = {};
    gs.forEach(function(g){ rc[g.ratio] = (rc[g.ratio] || 0) + 1; });
    gs.forEach(function(g, i){ if (!g.ratio) g.ratio = String(i + 1); else if (rc[g.ratio] > 1) g.ratio += ' · ' + g.lines[0].n; });
    var img = q('.aa-ps-crop__img', box), chipsEl = q('[data-ps-chips]', root), ghostsEl = q('[data-ps-ghosts]', box),
        act = q('[data-ps-box]', box), lb = q('[data-ps-lb]', box), live = q('[data-ps-live]', root), thumb = box.getAttribute('data-ps-thumb');
    function place(el, b){
      el.style.left = (b[0] * 100).toFixed(3) + '%';
      el.style.top = (b[1] * 100).toFixed(3) + '%';
      el.style.width = ((b[2] - b[0]) * 100).toFixed(3) + '%';
      el.style.height = ((b[3] - b[1]) * 100).toFixed(3) + '%';
    }
    var chips = [], frs = [], ghosts = [];
    gs.forEach(function(g, i){
      var c = document.createElement('button');
      c.type = 'button'; c.className = 'aa-ps-chip'; c.setAttribute('aria-pressed', 'false'); c.setAttribute('aria-label', g.long);
      var fr = document.createElement('span'), tx = document.createElement('span');
      fr.className = 'aa-ps-chip__ic'; fr.setAttribute('aria-hidden', 'true');
      tx.className = 'aa-ps-chip__t'; tx.textContent = g.ratio;
      c.appendChild(fr); c.appendChild(tx); frs.push(fr);
      var sel = document.createElement('span'); sel.className = 'aa-ps-chip__sel'; sel.textContent = 'Your size'; c.appendChild(sel);
      c.addEventListener('click', function(){ picked = true; stop(); show(i, true); });
      if (chipsEl) chipsEl.appendChild(c);
      chips.push(c);
      if (gs.length > 1 && ghostsEl) { var gh = document.createElement('span'); gh.className = 'aa-ps-crop__ghost'; place(gh, g.b); ghostsEl.appendChild(gh); ghosts.push(gh); }
    });
    // Each chip carries a small outline in its crop's proportions; the sizes themselves are written on the picture.
    function iar(){
      var w = (img && img.naturalWidth) || (img && +img.getAttribute('width')) || 4,
          h = (img && img.naturalHeight) || (img && +img.getAttribute('height')) || 3;
      return w / h;
    }
    function shape(){
      var ar = iar();
      gs.forEach(function(g, i){
        var b = g.b, w = Math.max(.01, b[2] - b[0]), h = Math.max(.01, b[3] - b[1]), fr = frs[i];
        fr.style.setProperty('--ar', (ar * w / h).toFixed(4));
      });
    }
    shape();
    if (img && !img.complete) img.addEventListener('load', shape);

    var cur = -1, picked = false, seen = false, hover = false, timer = 0, poll = 0, spins = 0, done = false, last = null, gsel = -1;
    // Label on the picture: 'Your size' (when it is) and one line per group of formats with their sizes.
    function label(i){
      if (!lb || i < 0) return;
      lb.textContent = '';
      if (i === gsel) { var y = document.createElement('span'); y.className = 'aa-ps-crop__you'; y.textContent = 'Your size'; lb.appendChild(y); }
      gs[i].lines.forEach(function(l){
        var r = document.createElement('span'), b = document.createElement('b');
        r.className = 'aa-ps-crop__ln'; b.textContent = l.s;
        r.appendChild(b); r.appendChild(document.createTextNode(' ' + l.n)); lb.appendChild(r);
      });
    }
    function show(i, say){
      cur = i; place(act, gs[i].b);
      label(i);
      chips.forEach(function(c, j){ c.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      ghosts.forEach(function(gh, j){ gh.style.visibility = j === i ? 'hidden' : ''; });
      if (say && live) live.textContent = 'Crop for ' + gs[i].long + '. Shaded areas fall outside the print.';
    }
    function field(){
      var pid = root.getAttribute('data-pid');
      return (pid && document.querySelector('form[action*="/cart/add"][data-productid="' + pid + '"] [name="id"]')) ||
             document.querySelector('form[action*="/cart/add"] [name="id"]');
    }
    function selId(){
      var f = field(), v = f && f.value;
      if (!v) { try { v = new URLSearchParams(location.search).get('variant'); } catch (e) {} }
      return String(v || root.getAttribute('data-ps-sel') || '');
    }
    function sync(){
      var id = selId();
      if (id === last) return;
      var first = last === null; last = id;
      gsel = -1;
      for (var i = 0; i < gs.length; i++) { if (gs[i].v[id]) { gsel = i; break; } }
      chips.forEach(function(c, j){ c.classList.toggle('is-sel', j === gsel); c.setAttribute('aria-label', gs[j].long + (j === gsel ? ', your size' : '')); });
      label(cur);
      if (gsel > -1 && (!picked || !first)) { show(gsel, false); if (!first) { picked = true; stop(); } }
    }
    function stop(){ if (timer) { clearInterval(timer); timer = 0; } }
    // One tour through the crops, then it rests on the selected size (or the first crop).
    function tick(){
      if (done || picked || !seen || hover || document.hidden || gs.length < 2) return;
      spins++;
      if (spins >= gs.length) { done = true; stop(); show(gsel > -1 ? gsel : 0, false); return; }
      show((cur + 1) % gs.length, false);
    }
    show(0, false);
    sync();
    box.classList.add('is-ready');
    var media = box.closest('.aa-ps-visual') || box;
    media.addEventListener('mouseenter', function(){ hover = true; });
    media.addEventListener('mouseleave', function(){ hover = false; });
    media.addEventListener('focusin', function(){ hover = true; });
    media.addEventListener('focusout', function(){ hover = false; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(es){
        seen = es[es.length - 1].isIntersecting;
        if (seen) sync();
        if (seen && !timer && !done && !picked && !RM) timer = setInterval(tick, 3400);
        if (!seen) stop();
        if (seen && !poll) poll = setInterval(sync, 1200);
        if (!seen && poll) { clearInterval(poll); poll = 0; }
      }, { threshold: .35 }).observe(box);
    }
    var f = field();
    if (f) f.addEventListener('change', function(){ setTimeout(sync, 30); });
    document.addEventListener('change', function(){ setTimeout(sync, 60); }, true);
    document.addEventListener('click', function(){ setTimeout(sync, 150); setTimeout(sync, 700); }, true);
    window.addEventListener('popstate', sync);
  }

  /* Phones: fold panel bodies behind a button */
  function folds(root){
    qa('[data-ps-acc]', root).forEach(function(btn){
      var host = btn.closest('[data-ps-fold]'), t = q('[data-ps-acc-t]', btn);
      if (!host) return;
      function set(open){
        host.classList.toggle('is-col', !open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (t) t.textContent = btn.getAttribute(open ? 'data-close' : 'data-open') || '';
        if (open) qa('.aa-ps-rv', host).forEach(function(el){ el.classList.add('is-in'); });
      }
      host._psOpen = function(){ set(true); };
      set(false);
      btn.addEventListener('click', function(){ set(host.classList.contains('is-col')); });
    });
  }

  function index(root){
    qa('.aa-ps-index a', root).forEach(function(a){
      a.addEventListener('click', function(e){
        var id = (a.getAttribute('href') || '').slice(1), t = document.getElementById(id);
        if (!t) return;
        e.preventDefault();
        if (t._psOpen && t.classList.contains('is-col')) t._psOpen();
        t.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
        var h = document.getElementById('aa-ps-h-' + id.replace('aa-ps-', ''));
        if (h) {
          if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1');
          try { h.focus({ preventScroll: true }); } catch (_) { h.focus(); }
        }
      });
    });
  }

  function copy(root){
    var b = q('[data-ps-copy]', root), m = q('[data-ps-mail]', root), t = q('[data-ps-copy-t]', root), live = q('[data-ps-copy-live]', root);
    if (!b || !m) return;
    var timer = 0;
    function done(ok){
      if (t) t.textContent = ok ? 'Copied' : 'Select';
      if (live) live.textContent = ok ? 'Email address copied' : 'Email address selected, copy it with your keyboard';
      b.classList.toggle('is-done', !!ok);
      clearTimeout(timer);
      timer = setTimeout(function(){ if (t) t.textContent = 'Copy'; if (live) live.textContent = ''; b.classList.remove('is-done'); }, 2600);
    }
    function select(){
      try { var r = document.createRange(); r.selectNodeContents(m); var s = window.getSelection(); s.removeAllRanges(); s.addRange(r); } catch (e) {}
    }
    b.addEventListener('click', function(){
      var txt = (m.textContent || '').trim();
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(txt).then(function(){ done(true); }, function(){ select(); done(false); });
      } else {
        select();
        var ok = false;
        try { ok = document.execCommand('copy'); } catch (e) {}
        done(ok);
      }
    });
  }

  function init(root){
    if (root.__aaPs) return;
    root.__aaPs = 1;
    reveal(root);
    tabs(root, slider(root));
    crops(root);
    folds(root);
    index(root);
    copy(root);
  }
  function boot(){ qa('[data-aa-ps]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
